import { useState } from "react";
import { CoreButton, CoreFormLabel, CoreModal, CoreModalDescription, CoreTextField } from "@verity/components/core";
import i18n from "../../i18n";
import styles from "./ResolveModal.module.css";

export default function ResolveModal({
	onClose,
	comment,
	onConfirm,
}: {
	onClose: () => void;
	comment?: string;
	onConfirm: (comment: string) => Promise<void>;
}) {
	const [commentText, setCommentText] = useState(comment || "");

	return (
		<CoreModal
			open
			onClose={onClose}
			title={i18n.t("result.components.resolveModalTSX.title")}
			buttons={
				<>
					<CoreButton color="secondary" onClick={onClose}>
						{i18n.t("result.components.resolveModalTSX.cancel")}
					</CoreButton>
					<CoreButton
						onClick={async () => {
							try {
								await onConfirm(commentText);
								onClose();
							} catch (e) {
								console.error(e);
							}
						}}
					>
						{i18n.t("result.components.resolveModalTSX.resolve")}
					</CoreButton>
				</>
			}
		>
			<div className={styles.resolveModalContent}>
				<CoreModalDescription>{i18n.t("result.components.resolveModalTSX.description")}</CoreModalDescription>
				<CoreFormLabel
					labelPlacement="top"
					header={i18n.t("result.components.resolveModalTSX.comment")}
					control={
						<CoreTextField
							multiline
							minRows={3}
							maxRows={3}
							maxLength={500}
							placeholder={i18n.t("result.components.resolveModalTSX.enterComment")}
							value={commentText}
							onChange={(e) => setCommentText(e.target.value)}
						/>
					}
				/>
			</div>
		</CoreModal>
	);
}
